module.exports = __webpack_public_path__ + "img/no-logo.7d23f0c.jpg";